<template>
  <div id="WebDownloadComponent">
    <gjw-dialog
        v-if="isR && noTimes"
        title="温馨提示"
        width="480px"
        custom-class="versionDialog"
        :showDialog="isShowDialog"
        :show-footer="false"
        @close="closeDialog"
    >
      <div class="dialog-content">
        <div class="tips">
          <p class="tip-text">你今天的下载额度已经用完了，可以明天再来哦~</p>
          <p class="tip-text">你也可以选择安装构件坞插件，万千资源任你使用！</p>
        </div>
        <div class="tip-btn">
          <a :href="revitUrl" target="_blank" class="btn-orange">构件坞插件下载</a>
        </div>
      </div>
    </gjw-dialog>
    <gjw-dialog
        v-else
        title="选择版本"
        width="660px"
        custom-class="versionDialog"
        :showDialog="isShowDialog"
        :show-footer="false"
        @close="closeDialog"
    >
      <div class="dialog-content">
        <template v-if="versions.length">
          <ul class="version-ul">
            <li v-for="(v, index) in versions" :key="index" class="version-li" @click="selectVersion(v.value)">{{v.label}}</li>
          </ul>
          <div v-if="isR" class="revit-limit">
            <span>你的Revit构件每日下载额度为 <span class="number">{{totalTimes}}</span> 个，今日还可用 <span class="number">{{remainTimes}}</span> 个。</span>
            <span @click="trackDownload"><a :href="revitUrl" target="_blank" class="revit-link">安装Revit插件</a></span>
            <span class="ft-theme">，每日下载不限量!</span>
          </div>
        </template>
        <div v-else class="no-version">暂无可下载的资源。</div>
      </div>
      <div class="footer" @click="toParamodel">
        <div class="desc-large">国产基础建模软件——数维构件设计（NOVADESIGN Paramodel）</div>
        <div class="desc-small">快来了解详情，学会了能赚钱哦！</div>
      </div>
    </gjw-dialog>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import GjwDialog from '@/components/lib/GjwDialog.vue'
export default {
  name: 'WebDownloadComponent',
  props: {
    from: {
      type: String,
      default: 'product_detail'
    },
    // 从不同父组件进入时，可以携带不同的埋点参数
    trackParams: {
      type: Object,
      default() {
        return {}
      }
    },
  },
  components: { GjwDialog },
  data() {
    return {}
  },
  computed: {
    ...mapGetters({
      componentInfo: 'componentDownload/componentInfo',
      versions: 'componentDownload/versions',
      isR: 'componentDownload/isR',
      noTimes: 'componentDownload/noTimes',
      totalTimes: 'componentDownload/totalTimes',
      remainTimes: 'componentDownload/remainTimes',
      revitUrl: 'componentDownload/revitUrl',
    }),
    productId() {
      return this.from === 'product_detail' ? this.$route.params.id : null
    },
    isShowDialog: {
      get() {
        return this.$store.state.componentDownload.showDialog
      },
      set(val) {
        this.$store.commit('componentDownload/setShowDialog', val)
      }
    },
  },
  methods: {
    closeDialog() {
      this.isShowDialog = false
    },
    async selectVersion(v) {
      try {
        this.$message.success(this.$t('load.downloading'))
        const { platformCode, softwareCode } = this.componentInfo
        this.closeDialog() // 此处关闭 减少异步请求结果返回时间 防止用户连续点击
        let url
        const productId = this.productId
        const publicComponentId = this.componentInfo.publicComponentId || this.componentInfo.id
        const componentFamilyTypeName = this.componentInfo.componentFamilyTypeName || null
        if (platformCode === 'NOVA_DESIGN') {
          url = await this.$api.download.novaDownloadUrl(softwareCode, publicComponentId, { productId, software_version: v, family_type_name: componentFamilyTypeName })
        } else if (platformCode === 'REVIT') {
          url = await this.$api.download.revitDownloadUrl(publicComponentId, { productId, platform: 'revit', version: v })
        } else {
          url = await this.$api.download.generalDownloadUrl(publicComponentId, { productId, software_code: softwareCode, software_version: v })
        }
        if (url) {
          const tempWin = window.open('', '_self')
          tempWin.location.href = url
          this.$tracks({
            event: 'shopComponentDownload',
            params: {
              g_c_component_id: publicComponentId,
              g_c_component_version: v,
              g_c_product_id: productId || null,
              g_c_source: 'product_detail',
              g_c_sorting: this.componentInfo.sortIndex || null,
              ...this.trackParams,
            }
          })
        } else {
          this.$message.error('下载失败：没有获取到下载地址')
        }
      } catch (err) {
        this.$message.error('下载失败：没有获取到下载地址')
      }
    },
    toParamodel() {
      window.open(`${process.env.VUE_APP_GJW_PORTAL_URL}/paramodel/introduction`, '_blank')
    },
    // 下载插件的打点
    trackDownload() {
      this.$tracks({
        event: 'downloadPlugin',
        params: {
          source: 'Download_Popup'
        }
      })
    }
  }
}
</script>

<style lang="less">
  .versionDialog{
    .el-dialog__body{
      padding: 0;
    }
    .el-tabs__item.is-active{
      color: @theme-grey-2;
    }
  }
</style>
<style lang="less" scoped>
  .number{
    color: @theme-orange;
    font-weight: bold;
    font-size: 16px;
  }
  .dialog-content{
    padding: 0 20px;
  }
  .tips{
    padding: 16px 0;
    .tip-text{
      text-align: center;
    }
  }
  .tip-btn{
    text-align: center;
    padding: 10px 0 30px;
    .btn-orange{
      display: inline-block;
      width: 128px;
      height: 40px;
      line-height: 40px;
      border-radius: 2px;
      background: @theme-orange;
      color: @white;
      cursor: pointer;
      &:hover{
        background: @theme-orange-hover;
        box-shadow: 0 4px 12px 0 rgba(60, 130, 180, 0.5);
      }
    }
  }
  .version-ul{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    .version-li{
      cursor: pointer;
      min-width: 128px;
      height: 32px;
      line-height: 32px;
      text-align: center;
      border-radius: 2px;
      background: #e1e1eb;
      margin: 0 24px 16px 0;
      &:hover{
        color: #fff;
        background: @theme-hover-color;
      }
    }
  }
  .revit-limit{
    margin-top: 12px;
    padding: 20px 0;
    border-top: 1px solid @theme-border-color;
    line-height: 32px;
  }
  .revit-link{
    cursor: pointer;
    text-decoration: underline;
  }
  .no-version{
    text-align: center;
    padding: 16px 0 42px;
  }
  .footer{
    cursor: pointer;
    height: 80px;
    color: @white;
    text-align: center;
    padding: 18px 0 0 80px;
    background-image: url("~@/assets/image/g-ad.png");
    background-size: cover;
    .desc-large{
      font-size: 16px;
      font-weight: 400;
      margin-bottom: 4px;
    }
    .desc-small{
      font-weight: 400;
    }
  }
</style>
